import { Flex as AntdFlex } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { FlexProps } from 'antd';

export const Flex = createGuardedComponent(AntdFlex) as typeof AntdFlex;
